import { render, staticRenderFns } from "./ConsistentSourcesCard.vue?vue&type=template&id=6b6fee38&scoped=true"
import script from "./ConsistentSourcesCard.vue?vue&type=script&lang=js"
export * from "./ConsistentSourcesCard.vue?vue&type=script&lang=js"
import style0 from "./ConsistentSourcesCard.vue?vue&type=style&index=0&id=6b6fee38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6fee38",
  null
  
)

export default component.exports